import React from 'react';
import { Route, Redirect } from 'react-router';
import { AuthLogic } from '../auth/AuthLogic';
import { RouteProps } from 'react-router';

// tslint:disable-next-line:no-any
export default class PrivateRoute extends React.PureComponent<RouteProps> {
    public render() {
        // tslint:disable-next-line:no-any
        const Component = this.props.component as any;

        return (
            <Route
                {...this.props}
                render={props =>
                    AuthLogic.getInstance().isAuthenticated() ? (
                        <Component {...props} />
                    ) : (
                        <Redirect to="/" />
                    )
                }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/PrivateRoute.tsx